import { v4 } from "uuid";
export const delayMs = (ms) => new Promise((res) => setTimeout(res, ms));
export const uuidv4 = () => {
    return v4();
};
export function cloneObj(obj) {
    return JSON.parse(JSON.stringify(obj));
}
